import { apiFetchShopper } from "./api";

export async function fetchWardrobe() {
  return apiFetchShopper("/shopper/wardrobe");
}

export async function addToWardrobe(item) {
  return apiFetchShopper("/shopper/wardrobe", {
    method: "POST",
    body: JSON.stringify(item),
  });
}

export async function removeFromWardrobe(id) {
  return apiFetchShopper(`/shopper/wardrobe/${id}`, {
    method: "DELETE",
  });
}